// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__1Cm2h","resendInfoText":"OnGoingPaymentBox_resendInfoText__1G5J9"};